export default __webpack_public_path__ + "static/media/london-bottom-min-1.97fe38b1.webp";